import React, {useState} from "react"

import {PropTypes} from "prop-types"
import {Field} from "redux-form"
import {Icon, Input, Popup} from "semantic-ui-react"

import {isKeyboardClickEvent} from "../../utils/accessibilityUtil"
import SemanticFormField from "../SemanticFormField/semanticFormField"
import { useTexts } from "../../hooks/useTexts"

/**
 * A form password component.
 */
const PasswordField = ({withFaIcons = false, ...props}) => {
    const texts = useTexts()
    const [type, setType] = useState("password")

    const ariaLabel = type === "password" ? texts.passwordFieldPasswordTypePopup : texts.passwordFieldTextTypePopup

    const switchFieldType = () => setType(type === "password" ? "text" : "password")

    const handleKeyDown = event => {
        if (isKeyboardClickEvent(event)) {
            event.preventDefault()
            switchFieldType()
        }
    }

    return (
        <Field
            as={Input}
            component={SemanticFormField}
            icon={
                <Popup
                    content={ariaLabel}
                    trigger={
                        withFaIcons ? (
                            <Icon
                                aria-label={ariaLabel}
                                circular={true}
                                className={type === "password" ? "fa-solid fa-eye" : "fa-solid fa-eye-slash"}
                                link={true}
                                onClick={switchFieldType}
                                onKeyDown={e => handleKeyDown(e)}
                                tabIndex={0}
                            />
                        ) : (
                            <Icon
                                aria-label={ariaLabel}
                                circular={true}
                                link={true}
                                name={type === "password" ? "eye" : "eye slash"}
                                onClick={switchFieldType}
                                onKeyDown={e => handleKeyDown(e)}
                                tabIndex={0}
                            />
                        )
                    }
                />
            }
            type={type}
            {...props}
        />
    )
}

PasswordField.propTypes = {
    withFaIcons: PropTypes.bool, // TODO A supprimer quand les packages Font Awesome Pro seront integrés dans tous les espaces
}

export default PasswordField
